import MyBus from './components/MyBus';

export default MyBus;
